module.exports = __webpack_public_path__ + "static/media/Maf_Curso_03TecnicasDeLitigacion.0d84a61b.jpg";